import React from "react";
import { Descriptions, Space, Tag, Typography } from "antd";

import { ReplicaTags } from "./logStateTags";
import { formatCount, formatDuration } from "../utils/formatters";
import { formatDateTime } from "shared/utils/datetime";

const { Text } = Typography;

const TagList = ({ values, color }) => {
  if (!values || values.length === 0) return <Text type="secondary">-</Text>;
  return (
    <Space size={2} wrap>
      {values.map((value) => (
        <Tag key={value} color={color}>
          {value}
        </Tag>
      ))}
    </Space>
  );
};

const orDash = (value) =>
  value ? value : <Text type="secondary">-</Text>;

const orTime = (value) =>
  value ? formatDateTime(value) : <Text type="secondary">-</Text>;

/**
 * Expanded-row panel for a log file.
 *
 * Every field here comes from the list response the table already holds, so
 * expanding a row costs no network request. Fields the list response does NOT
 * carry — tags, file hash, per-channel topics — stay in the detail modal,
 * which fetches the full record.
 */
const LogRowDetail = ({ record }) => (
  <div className="mcap-row-detail">
    <Descriptions size="small" column={{ xs: 1, sm: 2, lg: 3 }} colon={false}>
      <Descriptions.Item label="Tasks">
        <TagList values={record.tasks} color="blue" />
      </Descriptions.Item>
      <Descriptions.Item label="Objects">
        <TagList values={record.objects} color="green" />
      </Descriptions.Item>
      <Descriptions.Item label="Scene types">
        <TagList values={record.scene_types} color="purple" />
      </Descriptions.Item>

      <Descriptions.Item label="Location">
        {orDash(record.location)}
      </Descriptions.Item>
      <Descriptions.Item label="Recording start">
        {orTime(record.recording_start_time)}
      </Descriptions.Item>
      <Descriptions.Item label="Recording end">
        {orTime(record.recording_end_time)}
      </Descriptions.Item>

      <Descriptions.Item label="Duration">
        {formatDuration(record.duration_seconds)}
      </Descriptions.Item>
      <Descriptions.Item label="Messages">
        {formatCount(record.message_count)}
      </Descriptions.Item>
      <Descriptions.Item label="Channels">
        {record.channel_count || 0}
      </Descriptions.Item>

      <Descriptions.Item label="Uploaded by">
        {orDash(record.uploaded_by)}
      </Descriptions.Item>
      <Descriptions.Item label="Uploaded at">
        {orTime(record.uploaded_at)}
      </Descriptions.Item>
      <Descriptions.Item label="Recording state">
        {orDash(record.recording_state)}
      </Descriptions.Item>

      <Descriptions.Item label="Replicas" span={3}>
        <ReplicaTags locations={record.storage_locations} />
      </Descriptions.Item>
    </Descriptions>
  </div>
);

export default LogRowDetail;
